import { render, staticRenderFns } from "./BlockSelect.vue?vue&type=template&id=ed17f8a6"
import script from "./BlockSelect.vue?vue&type=script&lang=js"
export * from "./BlockSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports